<template>
  <div>
    <br class="hide-on-small-only">
    <div class="alert col-12" :class="`alert-${notification.type}`" role="alert" v-for="notification of nots.filter(n => !n.read)" :key="notification.id">
      {{ notification.content }}
      <span style="cursor: pointer; float: right;" @click="removeSubjectNotification(notification.id)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 212.982 212.982" style="enable-background:new 0 0 212.982 212.982;" xml:space="preserve" width="9px" height="9px"><g id="Close"><path style="fill-rule:evenodd;clip-rule:evenodd;" d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312   c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312   l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937   c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z" fill="#FFFFFF"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>
    </div>
    <div class="card row" v-if="doneLoading">
      <div class="col-md-12">
        <div class="row" v-if="ability_subjects.length === 0">
          <p style="text-align: center; font-weight: 600;">You havent passed any test so you cant edit your profile</p>
        </div>
        <div class="row ho" v-else>
          <div class="col-md-12 pt-3 elevated ase">
            <h5>Choose a subject to edit</h5>
            <table class="table-borderless" width="100%">
              <tbody>
                <tr v-for="abilitySubject of ability_subjects" :key="abilitySubject.id">
                  <td style="font-weight: bold;">{{ abilitySubject.subject.name }}</td>
                  <td>
                    <router-link :to="{ name: dashOrNot, params: { ability_subject_id: abilitySubject.id } }" class="btn btn-info sbtn hide-on-small-only">Edit</router-link >
                    <router-link :to="{ name: dashOrNot, params: { ability_subject_id: abilitySubject.id } }" class="hide-on-med-and-up"><i class="fa fa-edit"></i></router-link >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row aro">
            <p><span v-show="ability_subjects.length === 0">You have not passed any test</span></p>
            <div class="actions">
              <button class="btn btn-success pull-right submit-button mx" v-show="notDash && stuffclosed" @click="nextStage">Move to next stage</button>
            </div>
          </div>
          <div class="col-md-12 pt-1 elevated ase mt-4 pt-3">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" v-else>
      <div class="row">
        <div class="col text-center">
          <spinner></spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import Spinner from '@/components/Preloaders/Spinner';

export default {
  name: 'all-subject-profiles',
  components: { Spinner },
  data() {
    return {
      apiUrl: `${BASE_API}/v1/tutor/`,
      profiles: [],
      ability_profiles: [],
      ability_subjects: [],
      doneLoading: false,
      nots: [],
      r: [],
    };
  },
  mounted() {
    this.fetchAbilitySubjects();
    this.fetchProfiles();
    for (let n of  this.$auth.user().subject_notifications) {
      this.r.push(n);
      this.nots.push(n);
    }
  },
  computed: {
    u() {
      return this.$auth.user();
    },
    dashOrNot() {
      return (this.$route.path.indexOf('dashboard') >= 0) ? 'subject-profiles-edit-dash' : 'subject-profiles-edit';
    },
    notDash() {
      return (this.$route.path.indexOf('dashboard') < 0);
    },
    stuffclosed() {
      console.log(this.$route.name);
      return this.$route.name === 'subject-profiles';
    },
  },
  methods: {
    fetchProfiles() {
      const tutorId = this.$auth.user().id;
      const url = `${this.apiUrl}subject-profile/${tutorId}/profiles`;
      this.doneLoading = false;

      this.$http.get(url)
        .then((response) => {
          this.profiles = response.data;
          this.doneLoading = true;
        })
        .catch(error => console.error(error));

      this.doneLoading = false;

      this.$http.get(`${this.apiUrl}ability-subjects/profiles`)
        .then((response) => {
          this.$store.commit('SET_SUBJECT_PROFILES', response.data.data);
          this.doneLoading = true;
        })
        .catch(error => console.error(error));
    },
    fetchAbilitySubjects() {
      this.doneLoading = false;

      this.$http.get(`${this.apiUrl}ability-subjects`)
        .then((response) => {
          this.ability_subjects = response.data.data;
          this.doneLoading = true;
          this.listen();
          if (typeof this.$route.params.ability_subject_id === 'undefined' && this.ability_subjects.length) {
            if (this.$route.path.indexOf('dashboard') >= 0) {
              this.$router.push({
                name: 'subject-profiles-edit-dash',
                params: { ability_subject_id: this.ability_subjects[0].id },
              });
            } else {
              this.$router.push({
                name: 'subject-profiles-edit',
                params: { ability_subject_id: this.ability_subjects[0].id },
              });
            }
          }
        })
        .catch(error => console.error(error));
    },
    removeSubjectNotification(id) {
      const nots = this.r.findIndex(n => n.id === id);
      this.r[nots].read = true;
      this.nots.splice(nots, 1);
      const notifications = [];

      for (let notification of this.r) {
        notifications.push(notification);
      }

      this.$store.dispatch('updateSubjectNotifications', notifications)
        .then(response => console.log(response))
        .catch(response => swal('Failed', response, 'error'));
    },
    listen() {
      for (let ab of this.ability_subjects) {
        Echo.channel(`tutor-${this.$auth.user().id}-subject-${ab.id}-notifications`)
          .listen('NewSubjectNotification', ({subject_notification}) => {
            this.r.push(subject_notification);
            this.nots.push(subject_notification);
          });
      }
    },
    nextStage() {
      axios.post(`${BASE_API}/v1/tutor/steps`, { step: 'academic_info' })
        .then(() => this.$store.dispatch('getUserTutor'))
        .then(() => {
          this.$router.push({ name: 'how-it-works-setup' });
        })
        .catch(err => console.error(err));
    },
  },
  filters: {
    truncate(text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },
};
</script>

<style lang="scss" scoped>
  .hide {display: none;}
  .ho {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 !important;
    padding: 0 40px;

    .le {
      height: 493px;
      border: 1px solid #f3f3f4;
      border-left: none;
      border-top: none;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-top: 40px;

      h5 {
        font-size: 18px;
        font-weight: bold;
      }
      a {
        margin: 15px;
        cursor: pointer;
        font-weight: 600;
        color: #333333;

        &.active { color: #639440 !important; }
      }
    }
    .ri {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: stretch;
      justify-content: center;
    }
  }
.ase {
  margin-bottom: 35px;
  padding: 15px;
  h5 {
    font-size: 18px;
    font-weight: 800;
    width: 100%;
    border-bottom: 1px solid #ededed;
    padding-bottom: 5px;
    margin-bottom: 15px;
  }
}
.panel-body {
  padding: 15px 10px !important;
}
.submit-button {
  min-width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  float: right;
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.sbtn {
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14), 0 3px 1px -2px rgba(112, 112, 112, 0.12), 0 1px 5px 0 rgba(112, 112, 112, 0.2);
  float: right;
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.title {
  svg {
    float: right;
    height: 18px;
    width: 18px;
    margin: 0 15px;
  }
}
.elevated {
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(150,150,150,0.14), 0 3px 1px -2px rgba(150,150,150,0.12), 0 1px 5px 0 rgba(150,150,150,0.2);
}
.hold {
  margin: 60px 0;
}
.table-borderless {
  td {padding-bottom: 10px;}
}
.mx { margin: 0 10px; }
.aro {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 25px 0 0 0;
}
@media only screen and (max-width: 600px) {
  .hold {margin-bottom: 35px; margin-top: 20px;}
  .title {font-size: 16px;}
  .lssa {
    padding: 15px 0;
    h5 {font-size: 16px;}
    .sublist {
      margin-bottom: 10px;
      overflow: hidden;
      overflow-x: auto;
      ul {
        li {flex-shrink: 0; font-size: 10px;}
      }
    }
  }
  .card {
    padding-top: 20px;
  }
  .ho {padding: 0;}
  .submit-button:not(.ignore) {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    margin: 0;
    left: 0;
    border-radius: 0;
    text-transform: uppercase;
    z-index: 1000;
  }
}
@media only screen and (max-width: 600px) {
  .hold {margin-bottom: 35px; margin-top: 20px;}
  .title {font-size: 16px;}
  .panel-body {margin-top: 15px; padding: 0 !important;}
  .ase {padding: 10px; margin-bottom: 25px; h5 {font-size: 14px;}}
  table.table-borderless {font-size: 10px !important;}
  .submit-button:not(.ignore) {
    // position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    left: 0;
    border-radius: 0;
    text-transform: uppercase;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Profile/AcademicInfo/AllSubjectProfiles.vue